import { useEffect, useState } from "react";

const navLinks = [
  { href: "#reviews", label: "测评精选" },
  { href: "#stores", label: "探店实录" },
  { href: "#unbox", label: "美食开箱" },
  { href: "#ranking", label: "人气榜单" },
  { href: "#method", label: "测评方法" },
  { href: "#faq", label: "常见问答" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/95 shadow-[0_1px_0_0_rgba(0,0,0,0.06)] backdrop-blur" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-e-bike-2-line text-lg" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <strong
              className={`font-heading text-base font-bold ${solid ? "text-foreground-950" : "text-background-50"}`}
            >
              美味的快递
            </strong>
            <span className={`text-[11px] ${solid ? "text-foreground-500" : "text-background-200"}`}>
              测评 · 外卖 · 探店
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors cursor-pointer ${
                solid
                  ? "text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950"
                  : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            订阅更新
          </a>
          <button
            type="button"
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
            className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
              solid ? "text-foreground-900 hover:bg-secondary-100" : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <nav className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <div className="grid grid-cols-2 gap-1.5">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950"
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="#subscribe"
            onClick={() => setMenuOpen(false)}
            className="mt-2 block rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
          >
            订阅更新
          </a>
        </nav>
      ) : null}
    </header>
  );
}